export default __webpack_public_path__ + "static/media/Ability_Warfare.deb2a3b9.png";